export default __webpack_public_path__ + "c9ca524.png";